import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApplicationService } from '../../shared/services/application/application.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { BaseComponent } from '../../shared/components/base-component';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { BUSINNESS, CHANNEL, COUNTRY, ENVIRONMENT, EVENT, FAMILY, PAGEVIEW, PRODUCT, SUBFAMILY } from '../../shared/constants/dali.constants';
import { getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { EApplication } from '../../shared/services/application/application.service';
import { StepsInformationModalComponent } from '../steps-information-modal/steps-information-modal.component';
export enum EActionDialog {
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM'
}

@Component({
  selector: 'app-fiducial-bank-home',
  templateUrl: './fiducial-bank-home.component.html',
  styleUrls: ['./fiducial-bank-home.component.scss']
})

export class FiducialBankHomeComponent extends BaseComponent implements OnInit {
  ACTIONS_DIALOG = EActionDialog;
  headerClass = 'portal-header';
  dialogShow = false;
  dialogChangeShow = false;
  CONTENT_BOUNDS: any[] | any;
  setting: any;

  optionRequestSelected: boolean = true;

  @Input() headerTitle: any = ""
  @Input() close = false;
  @Input() closeText: string = "Salir";

  @ViewChild('modalStepsInformation') modalStepsInformationRef!: StepsInformationModalComponent;
    
  constructor(
    private readonly _solicitation: RequestSolicitationsService,
    private readonly cps: CopyService,
    public readonly app: ApplicationService,
    private readonly link: LinkupService
  ) {
    super(app, link, "fiducial-bank-home");
  }

  ngOnInit(): void {
    this._solicitation.navigation.startFlow();
    this.app.channelId = "160";
    this.loadStaticValues();
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    await super.onLoad();
    localStorage.removeItem("appCurrentApplication");
    this.CONTENT_BOUNDS = await this.cps.getCopy("fiducial-bank-home");
    this.headerTitle = getValueProperty(this.CONTENT_BOUNDS, 'section.header.title');
  }

  closeApp() {
    let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
    let events = [
      {
          "name": "{EVENT.E1setData.E1transactionName.path}",
          "value": EVENT.E1setData.E1transactionName.value
      }
    ]; 
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
    console.log("close");
  }

  async navigateTo(app: any) {        
    this.app.currentApplication = app;
    let eventSetting = this.getSetting("analytics", "trackEvent.e1", "");
    let events = [
      {
          "name": "{EVENT.pv1E1setData.pv1E1transactionName.path}",
          "value": EVENT.pv1E1setData.pv1E1transactionName.value
      }
    ]; 
    if(!eventSetting){
      eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
      events = [
        {
            "name": "{EVENT.pv1E2setData.pv1E2transactionName.path}",
            "value": EVENT.pv1E2setData.pv1E2transactionName.value
        }
      ]; 
    }    
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
    
    if(app == EApplication.FIDUCIAL){
      this.app.channelId = "160";
    } else {
      await this._solicitation.navigation.nextStep();
    }

    /**
     * @todo Redireccionamiento fiduciaria
     * https://itau.comforce.co/tareas/clientes/create 
     * window.open('https://itau.comforce.co/tareas/clientes/create', '_blank');
     */

  }
}
